(function() {

    'use strict';

    angular.module('Services').factory('ConfirmationModalFactory', ConfirmationModalFactory);

    function ConfirmationModalFactory($uibModal, $document){

        return function (prop, scope){

            var modalProperties = {
                animation: false,
                windowClass: 'confirmation-modal fade',
                ariaDescribedBy: 'modal-body',
                templateUrl: '/templates/elements/warning-popover.html',
                controller: function($uibModalInstance, $scope){
                    $scope.action = function(cond){
                        $uibModalInstance.close(cond);
                    };
                    $scope.buttonLabel = {
                        true: 'Yes',
                        false: 'No'
                    };
                    if(scope){
                        angular.extend($scope, scope);
                    }
                },
                size: 'md',
                backdrop: 'static'
            };
            angular.extend(modalProperties, prop);
            function setInstance(prop, scope) {
                if(prop){
                    angular.extend(modalProperties, prop);
                }
                if(scope){
                    modalProperties.controller = function($uibModalInstance, $scope){
                    $scope.action = function(cond){
                        $uibModalInstance.close(cond);
                    };
                    $scope.buttonLabel = {
                        true: 'messages.warning.viewChange.ACTION_TRUE',
                        false: 'messages.warning.viewChange.ACTION_FALSE'
                    };
                    if(scope){
                        angular.extend($scope, scope);
                    }
                };
                }
            };
            function getInstance() {
                return $uibModal.open(modalProperties);
            };

            this.getInstance = getInstance;
            /*return {
                setInstane: setInstance,
                getInstance: getInstance
            };*/
        };
    };
})();


// WEBPACK FOOTER //
// ./js/services/UX/ConfirmationModalFactory.js